import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var capitaliseFirstLetter = function capitaliseFirstLetter(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
};
export var getFormAnalyticsAttributes = function getFormAnalyticsAttributes(form) {
  var _form$publish, _form$publish2, _jiraConfig$issueRequ, _jiraConfig$issueRequ2, _portalConfig$portalR, _portalConfig$portalR2, _jiraConfig$newIssueI, _jiraConfig$newIssueI2, _jiraConfig$newIssueR, _jiraConfig$newIssueR2;
  var jiraConfig = (_form$publish = form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.jira;
  var portalConfig = (_form$publish2 = form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal;
  var design = form.design;
  var questions = Object.entries(design.questions);
  var sections = Object.values(design.sections);
  var conditions = Object.values(design.conditions);
  var questionsAttributes = {};
  var questionsRequiredAttributes = {};
  var questionsUsedAsSectionConditionAttributes = {};
  var jiraFieldAttributes = {};
  var dataConnectionsAttributes = {};
  questions.forEach(function (_ref) {
    var _questionsAttributes$, _questionsRequiredAtt, _questionsUsedAsSecti;
    var _ref2 = _slicedToArray(_ref, 2),
      id = _ref2[0],
      question = _ref2[1];
    var questionType = capitaliseFirstLetter(question.type);
    var questionAttribute = "templateFormQuestion".concat(questionType, "Count");
    questionsAttributes[questionAttribute] = ((_questionsAttributes$ = questionsAttributes[questionAttribute]) !== null && _questionsAttributes$ !== void 0 ? _questionsAttributes$ : 0) + 1;
    var questionRequiredAttribute = "templateFormRequiredQuestion".concat(questionType, "Count");
    questionsRequiredAttributes[questionRequiredAttribute] = ((_questionsRequiredAtt = questionsRequiredAttributes[questionRequiredAttribute]) !== null && _questionsRequiredAtt !== void 0 ? _questionsRequiredAtt : 0) + (question.validation.rq ? 1 : 0);
    if (question.jiraField) {
      var _jiraFieldAttributes$;
      var jiraFieldAttribute = "templateFormJiraFieldQuestion".concat(questionType, "Count");
      jiraFieldAttributes[jiraFieldAttribute] = ((_jiraFieldAttributes$ = jiraFieldAttributes[jiraFieldAttribute]) !== null && _jiraFieldAttributes$ !== void 0 ? _jiraFieldAttributes$ : 0) + 1;
    }
    if (question.dcId) {
      var _dataConnectionsAttri;
      var dataConnectionAttribute = "templateFormDataConnectionQuestion".concat(questionType, "Count");
      dataConnectionsAttributes[dataConnectionAttribute] = ((_dataConnectionsAttri = dataConnectionsAttributes[dataConnectionAttribute]) !== null && _dataConnectionsAttri !== void 0 ? _dataConnectionsAttri : 0) + 1;
    }
    var questionUsedAsSectionConditionAttribute = "templateFormUsedAsSectionConditionQuestion".concat(questionType, "Count");
    var questionUsedAsSectionConditionCount = conditions.filter(function (condition) {
      var _condition$i$co;
      return (_condition$i$co = condition.i.co) === null || _condition$i$co === void 0 ? void 0 : _condition$i$co.cIds[id];
    }).length;
    questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute] = ((_questionsUsedAsSecti = questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute]) !== null && _questionsUsedAsSecti !== void 0 ? _questionsUsedAsSecti : 0) + questionUsedAsSectionConditionCount;
  });
  var layoutItemAttributes = {};
  var _recurseLayoutItemAttributes = function recurseLayoutItemAttributes(layoutItemNodes) {
    layoutItemNodes.forEach(function (layoutItemNode) {
      var _layoutItemAttributes, _layoutItemNode$conte;
      var layoutItemType = capitaliseFirstLetter(layoutItemNode.type);
      var layoutItemName = "templateFormLayoutItem".concat(layoutItemType, "Count");
      layoutItemAttributes[layoutItemName] = ((_layoutItemAttributes = layoutItemAttributes[layoutItemName]) !== null && _layoutItemAttributes !== void 0 ? _layoutItemAttributes : 0) + 1;
      _recurseLayoutItemAttributes((_layoutItemNode$conte = layoutItemNode.content) !== null && _layoutItemNode$conte !== void 0 ? _layoutItemNode$conte : []);
    });
  };
  _recurseLayoutItemAttributes(design.layout);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, questionsAttributes), questionsRequiredAttributes), questionsUsedAsSectionConditionAttributes), jiraFieldAttributes), dataConnectionsAttributes), layoutItemAttributes), {}, {
    templateFormQuestionsCount: questions.length,
    templateFormSectionsCount: sections.length,
    templateFormConditionalSectionsCount: sections.filter(function (section) {
      var _section$conditions;
      return (_section$conditions = section.conditions) === null || _section$conditions === void 0 ? void 0 : _section$conditions.length;
    }).length,
    templateFormConditionsCount: conditions.length,
    templateFormLinkedFieldsCount: questions.filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        question = _ref4[1];
      return question.jiraField;
    }).length,
    templateFormDataConnectionFieldsCount: questions.filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        question = _ref6[1];
      return question.dcId;
    }).length,
    templateFormRecommendedCount: (_jiraConfig$issueRequ = jiraConfig === null || jiraConfig === void 0 || (_jiraConfig$issueRequ2 = jiraConfig.issueRequestTypeIds) === null || _jiraConfig$issueRequ2 === void 0 ? void 0 : _jiraConfig$issueRequ2.length) !== null && _jiraConfig$issueRequ !== void 0 ? _jiraConfig$issueRequ : 0,
    templateFormPortalFormsCount: (_portalConfig$portalR = portalConfig === null || portalConfig === void 0 || (_portalConfig$portalR2 = portalConfig.portalRequestTypeIds) === null || _portalConfig$portalR2 === void 0 ? void 0 : _portalConfig$portalR2.length) !== null && _portalConfig$portalR !== void 0 ? _portalConfig$portalR : 0,
    templateFormIssueFormsCount: ((_jiraConfig$newIssueI = jiraConfig === null || jiraConfig === void 0 || (_jiraConfig$newIssueI2 = jiraConfig.newIssueIssueTypeIds) === null || _jiraConfig$newIssueI2 === void 0 ? void 0 : _jiraConfig$newIssueI2.length) !== null && _jiraConfig$newIssueI !== void 0 ? _jiraConfig$newIssueI : 0) + ((_jiraConfig$newIssueR = jiraConfig === null || jiraConfig === void 0 || (_jiraConfig$newIssueR2 = jiraConfig.newIssueRequestTypeIds) === null || _jiraConfig$newIssueR2 === void 0 ? void 0 : _jiraConfig$newIssueR2.length) !== null && _jiraConfig$newIssueR !== void 0 ? _jiraConfig$newIssueR : 0),
    isTemplateFormSubmitOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || false,
    isTemplateFormValidateOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.validateOnCreate) || false,
    isTemplateFormGeneratePDFOnSubmit: design.settings.submit.pdf,
    isTemplateFormLockOnSubmit: design.settings.submit.lock
  });
};
export var getTemplateFormAnalyticsAttributes = function getTemplateFormAnalyticsAttributes(updatedTemplateForm, oldTemplateForm) {
  var _oldTemplateForm$publ, _oldTemplateForm$publ2, _updatedTemplateForm$, _updatedTemplateForm$2;
  var updatedFormAttributes = getFormAnalyticsAttributes(updatedTemplateForm);
  var oldFormAttributes = getFormAnalyticsAttributes(oldTemplateForm);
  var deltaAttributes = {};
  var toggleAttributes = {};
  function addDeltaAttribute(numberAttributeKey) {
    var _ref7, _ref8;
    var oldValue = (_ref7 = oldFormAttributes[numberAttributeKey]) !== null && _ref7 !== void 0 ? _ref7 : 0;
    var newValue = (_ref8 = updatedFormAttributes[numberAttributeKey]) !== null && _ref8 !== void 0 ? _ref8 : 0;
    deltaAttributes["".concat(numberAttributeKey, "Delta")] = newValue - oldValue;
  }
  function addToggleAttribute(booleanAttributeKey) {
    var oldValue = oldFormAttributes[booleanAttributeKey];
    var newValue = updatedFormAttributes[booleanAttributeKey];
    if (oldValue && !newValue) {
      toggleAttributes["".concat(booleanAttributeKey, "Toggled")] = 'off';
    } else if (!oldValue && newValue) {
      toggleAttributes["".concat(booleanAttributeKey, "Toggled")] = 'on';
    }
  }
  Object.entries(updatedFormAttributes).forEach(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      key = _ref10[0],
      value = _ref10[1];
    if (typeof value === 'number') {
      addDeltaAttribute(key);
    } else if (typeof value === 'boolean') {
      addToggleAttribute(key);
    }
  });

  /**
   * Cover attributes that are undefined in `updatedFormAttributes`
   *
   * E.G.
   *   When user removed all 4 ChoiceDropdown questions, it would be
   *   oldFormAttributes = { templateFormQuestionCdCount: 4, ...rest };
   *   updatedFormAttributes = { templateFormQuestionCdCount: never, ...rest };
   *  */
  Object.entries(oldFormAttributes).forEach(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
      key = _ref12[0],
      value = _ref12[1];
    if (typeof value === 'number' && deltaAttributes["".concat(key, "Delta")] === undefined) {
      addDeltaAttribute(key);
    } else if (typeof value === 'boolean' && deltaAttributes["".concat(key, "Toggled")] === undefined) {
      addToggleAttribute(key);
    }
  });
  var oldPortalForms = (_oldTemplateForm$publ = (_oldTemplateForm$publ2 = oldTemplateForm.publish) === null || _oldTemplateForm$publ2 === void 0 || (_oldTemplateForm$publ2 = _oldTemplateForm$publ2.portal) === null || _oldTemplateForm$publ2 === void 0 ? void 0 : _oldTemplateForm$publ2.portalRequestTypeIds) !== null && _oldTemplateForm$publ !== void 0 ? _oldTemplateForm$publ : [];
  var newPortalForms = (_updatedTemplateForm$ = (_updatedTemplateForm$2 = updatedTemplateForm.publish) === null || _updatedTemplateForm$2 === void 0 || (_updatedTemplateForm$2 = _updatedTemplateForm$2.portal) === null || _updatedTemplateForm$2 === void 0 ? void 0 : _updatedTemplateForm$2.portalRequestTypeIds) !== null && _updatedTemplateForm$ !== void 0 ? _updatedTemplateForm$ : [];
  var templateFormPortalFormAdded = newPortalForms.filter(function (n) {
    return !oldPortalForms.includes(n);
  }).length;
  var templateFormPortalFormRemoved = oldPortalForms.filter(function (n) {
    return !newPortalForms.includes(n);
  }).length;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, updatedFormAttributes), deltaAttributes), toggleAttributes), {}, {
    templateFormPortalFormAdded: templateFormPortalFormAdded,
    templateFormPortalFormRemoved: templateFormPortalFormRemoved
  });
};